import { render, staticRenderFns } from "./grccms_accordion.vue?vue&type=template&id=1be3c04b&scoped=true&"
import script from "./grccms_accordion.vue?vue&type=script&lang=js&"
export * from "./grccms_accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be3c04b",
  null
  
)

export default component.exports